import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const validationSchema = Yup.object().shape({
  username: Yup.string().required("Le nom d'utilisateur est requis"),
  password: Yup.string().min(6, 'Le mot de passe doit avoir au moins 6 caractères').required('Le mot de passe est requis'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Les mots de passe doivent correspondre')
    .required('La confirmation du mot de passe est requise'),
  roles: Yup.string().oneOf(['SUPERADMIN', 'USER', 'ANONYM'], 'Rôle invalide').required('Le rôle est requis'),
});

function CreactUsers() {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onSubmit = (values, { resetForm }) => {
    const { username, password, roles, bataillonId } = values;
    axios
      .post('/auth', { username, password, roles, bataillonId })
      .then((response) => {
        toast.success(response.data.message || 'Utilisateur créé avec succès');
        navigate('/login');
      })
      .catch((error) => {
        setError(error.response?.data?.error || "Erreur d'enregistrement");
        console.error("Erreur lors de la création de l'utilisateur:", error);
      });
  };

  const inputCls = "w-full bg-slate-800 border border-cyan-500/30 text-white text-sm rounded-xl px-3 py-2 focus:outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all placeholder-slate-500";
  const labelCls = "block text-xs font-medium text-cyan-400 mb-1";
  const errorCls = "text-red-400 text-xs mt-1";

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-950 px-4 py-10">
      <div className="w-full max-w-md bg-gray-900 border border-gray-700 rounded-2xl p-6">

        <div className="flex items-center gap-2 mb-5">
          <i className="fa fa-user-plus text-green-400"></i>
          <h2 className="text-lg font-semibold text-white">Nouvel utilisateur</h2>
        </div>

        {error && (
          <div className="mb-4 flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3">
            <i className="fa fa-triangle-exclamation text-xs"></i>
            {error}
          </div>
        )}

        <Formik
          initialValues={{
            username: '',
            password: '',
            confirmPassword: '',
            roles: 'USER',
            bataillonId: '',
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="space-y-4" autoComplete="off">
              <div>
                <label htmlFor="username" className={labelCls}>Nom d'utilisateur</label>
                <Field type="text" id="username" name="username" autoComplete="off" className={inputCls} placeholder="Entrez le nom d'utilisateur" />
                <ErrorMessage name="username" component="div" className={errorCls} />
              </div>

              <div>
                <label htmlFor="password" className={labelCls}>Mot de passe</label>
                <Field type="password" id="password" name="password" autoComplete="new-password" className={inputCls} placeholder="Entrez le mot de passe" />
                <ErrorMessage name="password" component="div" className={errorCls} />
              </div>

              <div>
                <label htmlFor="confirmPassword" className={labelCls}>Confirmez le mot de passe</label>
                <Field type="password" id="confirmPassword" name="confirmPassword" autoComplete="new-password" className={inputCls} placeholder="Confirmez le mot de passe" />
                <ErrorMessage name="confirmPassword" component="div" className={errorCls} />
              </div>

              <div>
                <label htmlFor="roles" className={labelCls}>Rôle</label>
                <Field as="select" id="roles" name="roles" className={inputCls}>
                  <option value="">Sélectionnez un rôle</option>
                  <option value="SUPERADMIN">SUPERADMIN</option>
                  <option value="USER">USER</option>
                  <option value="ANONYM">ANONYM</option>
                </Field>
                <ErrorMessage name="roles" component="div" className={errorCls} />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="flex items-center justify-center gap-2 w-full px-5 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white text-sm font-medium rounded-xl transition-colors duration-200"
              >
                <i className="fa fa-check text-xs"></i>
                Créer l'utilisateur
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CreactUsers;